import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Instance } from 'src/app/models/instance/instance';
import { RouterSegments } from 'src/app/models/router-segments';
import { Sandbox } from 'src/app/models/sandbox';
import { ServiceCardInfo } from 'src/app/models/service/service-card-info';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TrialStatusService } from 'src/app/services/util/trial-status.service';
import { Constants } from 'src/app/models/constants';
import {SolutionVersionsInfo} from 'src/app/models/service/solution-versions-info';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';

@Component({
    selector: 'app-byob-sandbox-card',
    templateUrl: './byob-sandbox-card.component.html',
    styleUrls: ['./byob-sandbox-card.component.scss'],
    standalone: false
})
export class ByobSandboxCardComponent implements OnInit {
  @Input() loader: boolean;
  @Input() sandboxInfo: ServiceCardInfo;
  sandbox: Sandbox;
  trialStatus: string;
  instanceStatus: DeployStatus;
  versionInfo: any;
  capabilities: any;
  releaseVersion: any;
  isAMR= false;
  isSandbox: boolean;
  serviceVersionsInfo: SolutionVersionsInfo;


  Constants = Constants;

  readonly statusInfo: { [key: string]: any } = {
    [DeployStatus.DEPLOYED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.DEPLOYING]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'},
    [DeployStatus.TERMINATING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.TERMINATION_FAILED]: {icon: 'error_outline', colorClass: 'warn-solid-bg'},
    [DeployStatus.NOT_DEPLOYED]: {icon: 'close', colorClass: 'neutral-blue-6-bg'},
    [DeployStatus.UPDATED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.UPDATE_FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'}
  };
  DeployStatus = DeployStatus;

  constructor(private trialStatusService: TrialStatusService, private router: Router,
              private authService: AuthService, private solutionVersionsService: SolutionVersionsService) { }

  ngOnInit(): void {
    if(!this.loader) {
    this.capabilities = this.sandboxInfo?.latestVersion?.capabilities?.length;
    const demoInstance = this.sandboxInfo.instances?.find((instance) => instance.blueprintId === this.sandboxInfo.blueprint.id);
    this.versionInfo = this.sandboxInfo?.serviceVersionsInfo?.currentVersion?.version;
    this.releaseVersion = this.sandboxInfo?.serviceVersionsInfo?.currentVersion?.releaseVersion;
    if(demoInstance){
      this.trialStatus = this.trialStatusService.TrailStatusUTCFormat(demoInstance);
      this.sandbox = {
        service: this.sandboxInfo.service,
        instance: demoInstance
      };
      this.getInstanceStatus(demoInstance);
    }
    let releaseVersionText;
    if (this.isSandbox) {
      releaseVersionText = this.sandboxInfo?.serviceVersionsInfo?.devVersion?.releaseVersion;
    } else {
      releaseVersionText = this.sandboxInfo?.serviceVersionsInfo?.currentVersion?.releaseVersion;
    }

    if(this.solutionVersionsService.releaseVersion(releaseVersionText)) {
      this.isAMR = true;
    }
  }
  }

  getInstanceStatus(instance: Instance): void {
    const currentDate = +new Date();
    const instanceCreatedDate = new Date(instance.dateCreated);
    const maximumLoadingTime = instanceCreatedDate.setMinutes(instanceCreatedDate.getMinutes() + 5);
    if(currentDate > maximumLoadingTime && instance.status === DeployStatus.DEPLOYED) {
      this.instanceStatus = DeployStatus.DEPLOYED;
    }else {
      this.instanceStatus = DeployStatus.DEPLOYING;
    }
  }

  goToBlueprintSummary(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.sandbox.service.id,
    RouterSegments.BLUEPRINTS, this.sandbox.instance.blueprintId]);
  }

}
